import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import Order from '@/shared/types/order/order.type';
import formatCurrency from '@/shared/utils/formatCurrency';

interface OrderSummaryProps {
  order: Order;
}

const OrderSummary: FC<OrderSummaryProps> = ({ order }) => {
  const { t } = useTranslation(['orders']);

  const renderSummaryRow = (
    title: string,
    value: string,
    fontWeight?: string,
  ) => {
    return (
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant='body2'
          color='text.secondary'
          fontWeight={fontWeight}
        >
          {title}:
        </Typography>
        <Typography variant='body2' fontWeight={fontWeight}>
          {formatCurrency(parseFloat(value)) || '-'}
        </Typography>
      </Stack>
    );
  };

  return (
    <Stack>
      {renderSummaryRow(t('orders:subtotal'), order.sub_total)}
      {renderSummaryRow(t('orders:shippingPrice'), order.shipping_price)}
      {renderSummaryRow(t('orders:tax'), order.tax)}
      {renderSummaryRow(t('orders:total'), order.order_total, '700')}
    </Stack>
  );
};

export default OrderSummary;
